export default "__VITE_ASSET__C8LMk83O__"